import * as React from "react";
import * as _ from "lodash";
import * as moment from 'moment';
import { Dispatch, connect } from "react-redux";
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IOrganPickupDeliveryReportResponse } from "@nkr/store/index";
import { IOrganPickupDelivery } from '@nkr/models/index';
import { Button } from 'react-bootstrap';
import { CsvExportParams, GridApi, GridReadyEvent, ProcessCellForExportParams } from 'ag-grid-community';
import OrganPickupDeliveryReportGrid from "./organ-pickup-and-delivery-grid";

interface IOwnProps { }

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getOrganPickupDeliveryReport: () => Promise<IOrganPickupDeliveryReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    centerId: number,
    report: IOrganPickupDelivery[],
    gridApi: GridApi
}

class OrganPickupDeliveryReport extends React.Component<TProps, IState> {
    readonly state: IState = {
        centerId: 0,
        report: [],
        gridApi: null
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getOrganPickupDeliveryReport()
                .then((response: IOrganPickupDeliveryReportResponse) => {

                    this.setState({
                        report: response.data.results
                    });

                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }

    onGridReady = (e: GridReadyEvent) => {
        this.setState({
            gridApi: e.api
        });
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'organ-pickup-and-delivery.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank')
                    return params.node.rowIndex + 1;
                else if (colDef.colId == 'xpDate')
                    return moment(params.value).format('MM/DD/YYYY');

                if (colDef.colId == 'earlyPU' || colDef.colId == 'latestDT')
                    return params.value + ' ' + params.node.data['ctrTimeZone'];


                return params.value;
            }
        };

        this.state.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                    <div style={{ fontSize: 28, fontWeight: 500 }}>
                        Organ Pick Up and Delivery Report
                    </div>
                    <div>
                        <Button onClick={this.handleExport}>Export CSV</Button>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-sm-12'>

                        <OrganPickupDeliveryReportGrid
                            report={this.state.report}
                            onGridReady={this.onGridReady}
                        />
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getOrganPickupDeliveryReport: () => {
            return dispatch(ReportActionCreators.getOrganPickupDeliveryReport());
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(OrganPickupDeliveryReport);